export const roundToNDecimals = (value: number, decimals: number): number => {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
};
export const roundToOneDecimal = (value: number): number => roundToNDecimals(value, 1);
